import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ErrorPage from './pages/ErrorPage';
import LiveRoutes from './routes/LiveRoutes';
import ManageRoutes from './routes/ManageRoutes';
import AuthStore from './reducers/Auth/AuthContext';
import EventsStore from './reducers/Events/EventsContext';
import PlaceStore from './reducers/Place/PlaceContext';
import { WSProvider } from './contexts/WSContext';
import PrivateRoute from './routes/PrivateRoute';
import Modal from 'react-modal';

Modal.setAppElement('#root');

function App() {
  return (
    <div className="App" style={{ minHeight: '90vh' }}>
        <Router>
          <AuthStore>
            <PlaceStore>
              <EventsStore>
                <WSProvider>
                  <Switch>
                    <Route exact path="/">
                      <Redirect to={{ pathname: '/login', state: { from: '/' } }} />
                    </Route>
                    <Route exact path="/error" component={ErrorPage} />
                    <Route exact path="/login" component={LoginPage} />
                    <PrivateRoute path="/live">
                      <LiveRoutes />
                    </PrivateRoute>
                    <PrivateRoute path="/manage">
                      <ManageRoutes />
                    </PrivateRoute>
                  </Switch>
                </WSProvider>
              </EventsStore>
            </PlaceStore>
          </AuthStore>
        </Router>
    </div>
  );
}

export default App;
